module.exports = __webpack_public_path__ + "static/media/Industriekessel_07.db10a068.jpg";